export const MARKETPLACE_CUISINE_TYPES = [
  'hamburguesas',
  'tacos',
  'pizza',
  'saludable',
  'venezolano',
  'japones',
  'cafe',
  'carnes',
  'bar',
  'asiatico',
  'mediterraneo',
  'otro',
] as const

export type MarketplaceCuisine = typeof MARKETPLACE_CUISINE_TYPES[number]

export const CUISINE_LABELS: Record<MarketplaceCuisine, string> = {
  hamburguesas: 'Hamburguesas',
  tacos: 'Tacos',
  pizza: 'Pizza',
  saludable: 'Saludable',
  venezolano: 'Venezolano',
  japones: 'Japonés',
  cafe: 'Café',
  carnes: 'Carnes',
  bar: 'Bar',
  asiatico: 'Asiático',
  mediterraneo: 'Mediterráneo',
  otro: 'Otro',
}
